import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixFieldSet } from '../Fields/FieldsImport';
export class InstrumentIdGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.INSTRUMENT_ID_GROUP, null, pfixFieldSet);
    }
    setInstrumentId(id) {
        this.SetField(FieldsFactory.FIELD_INSTRUMENT_ID, id);
    }
}
